module.exports = __webpack_public_path__ + "img/logo_01.8d7e80e0.svg";